var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:`${_vm.small ? 'fid-small-logo-size' : ''}`,attrs:{"src":_vm.logo}})
}
var staticRenderFns = []

export { render, staticRenderFns }